/* @flow strict */

import * as React from 'react';
import { POST } from '/client/src/api/';
import NProgressCustom from '/client/src/components/nProgress';
import { Redirect } from 'react-router-dom';
// import CssPinner from '/client/src/components/csspinner';

const queryString = require('query-string');

// NProgressCustom(true/false);
// CssPinner = (el: string, status: boolean)

class PaymentStripe extends React.Component {
  constructor(props) {
    super(props);

    const parsed = queryString.parse(window.location.href);

    this.stripeToken = parsed.code;
    this.lastPage = window.localStorage.getItem('SPARXO_lastPage');

    this.state = {
      isError: false,
      isConnected: false
    };
  }

  componentDidMount() {
    this.handleConnectStripe();
  }

  handleConnectStripe = async () => {
    NProgressCustom(true);

    try {
      await POST('/api/v1/1/merchants/payment/stripe/connect', { code: this.stripeToken });

      this.setState({
        isConnected: true
      });

      NProgressCustom(false);
    } catch (e) {
      console.log(e);
      NProgressCustom(false);

      this.setState({
        isError: true
      });
    }
  }

  render(): React.Element<'div'> {
    const {
      isError,
      isConnected
    } = this.state;

    window.localStorage.removeItem('SPARXO_lastPage');

    return (
      <>
        {!isConnected && !isError &&
          <div className='csspinner' />
        }

        {isConnected &&
          <Redirect to={_.size(this.lastPage) ? this.lastPage : '/'} />
        }

        {isError &&
          <Redirect to='/' />
        }
      </>
    );
  }
}

export default PaymentStripe;
